import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../Utils/api';
import { BoletimContext } from '../context/BoletimContext';
import BoletimDetalheFromBD from '../pages/Boletim/BoletimDetalheFromBD';

export default function BoletimById() {
  const { id } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setReport(null);
    setError('');
    api.get(`/incidentReport/${encodeURIComponent(id)}`).then(({ data }) => {
      if (active) setReport(data);
    }).catch(error => {
      if (active) setError(error.response?.data?.message || 'Não foi possível consultar o boletim.');
    });
    return () => { active = false; };
  }, [id]);
  if (error) return <div role="alert">{error}</div>;
  if (!report) return <p>Carregando boletim...</p>;
  return <BoletimContext.Provider value={{ boletim: report }}><BoletimDetalheFromBD /></BoletimContext.Provider>;
}
